import { render } from "./ResultatsSurfaces.vue?vue&type=template&id=6b2760e0&scoped=true"
import script from "./ResultatsSurfaces.vue?vue&type=script&lang=js"
export * from "./ResultatsSurfaces.vue?vue&type=script&lang=js"

import "./ResultatsSurfaces.vue?vue&type=style&index=0&id=6b2760e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2760e0"]])

export default __exports__